// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2-DDL","image":"App_image__2CyKl"};